module.exports = __webpack_public_path__ + "static/media/keyResources.769e3873.svg";